import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "store/types";
import { USER_TYPE } from "types";

export const selectUserId = (state: RootState) => state.user.id;
export const selectUserType = (state: RootState) => state.user.user_type;
export const isUserMySelf = createSelector(
  [selectUserType],
  (user_type) => user_type === USER_TYPE.MYSELF
);
export const selectOrganizations = (state: RootState) =>
  state.auth.organizations;
